import { SemanticCOLORS } from "semantic-ui-react";
import { EAuditStatus } from "../interfaces/IAudit";

type TStatusColors = {
    [key in EAuditStatus]: SemanticCOLORS;
}

export const StatusColors: TStatusColors = {
    [EAuditStatus.Draft]: "orange",
    [EAuditStatus.Finished]: "red",
    [EAuditStatus.Unknown]: "grey",
};
